import VehicleOverlayMarker from './VehicleOverlayMarker';

export default VehicleOverlayMarker;



// WEBPACK FOOTER //
// ./src/common/components/VehicleOverlayMarker/index.js